import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Auth({ mode = "login" }) {
  const isLogin = mode === "login";
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", business_name: "", full_name: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isLogin) await login(form.email, form.password);
      else await register(form);
      toast.success(isLogin ? "Welcome back." : "Account created.");
      nav("/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Authentication failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid={`${mode}-page`} className="pt-32 min-h-screen">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16">
        <div className="hidden lg:block relative aspect-[3/4] overflow-hidden bg-[#F0EFEB]">
          <img src="https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=1400&q=85" alt="Med spa" className="w-full h-full object-cover" />
        </div>
        <div className="max-w-md mx-auto lg:mx-0 w-full">
          <div className="overline">Trade Portal</div>
          <h1 className="font-serif-editorial text-5xl mt-4 leading-none">{isLogin ? "Welcome back." : "Open your account."}</h1>
          <p className="mt-6 text-[#5C5C5C]">{isLogin ? "Access your orders, saved suites, and concierge tools." : "Create a TheraTec trade account for orders, saved suites and concierge access."}</p>

          <form onSubmit={submit} className="mt-12 space-y-8" data-testid="auth-form">
            {!isLogin && (
              <>
                <input data-testid="input-full-name" placeholder="Full name" className="tt-input" value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} />
                <input data-testid="input-business" placeholder="Med spa / business name" className="tt-input" value={form.business_name} onChange={(e) => setForm({ ...form, business_name: e.target.value })} />
              </>
            )}
            <input data-testid="input-email" type="email" required placeholder="Email address" className="tt-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input data-testid="input-password" type="password" required placeholder="Password" className="tt-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <button data-testid="submit-auth-btn" disabled={loading} className="tt-btn-primary w-full">{loading ? "…" : (isLogin ? "Sign In" : "Create Account")}</button>
          </form>

          <div className="mt-8 text-sm">
            {isLogin ? (
              <>New to TheraTec? <Link to="/register" data-testid="link-register" className="underline underline-offset-4">Create an account</Link></>
            ) : (
              <>Have an account? <Link to="/login" data-testid="link-login" className="underline underline-offset-4">Sign in</Link></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
